import { AfterContentInit, Component, ElementRef, Input, OnChanges, ViewChild } from "@angular/core";
import { IDateFormatOptions } from "@app/services/date.service";
import { SortDirection } from "@enums/SortDirection";
import { IPlot } from "@interfaces/IPlot";
import { VeriDate } from "@services/veriDate.service";
import "./v-timeline.component.scss";

export interface ITimelineEntry {
    date: Date;
    icon: string;

    largeDetails?: ITimelineEntryLargeForm;
    inlineDetails?: ITimelineEntryInline;

    showDateFooter?: boolean;
}

export interface ITimelineEntryWithData<T> extends ITimelineEntry {
    data?: T;
}


export interface ITimelineEntryLargeForm extends ITimelineEntryCommon {
    title?: string;
    text?: string;
    listItems?: { verb: string; date?: Date }[];
}

export interface ITimelineEntryInline extends ITimelineEntryCommon {
    subject?: string; // e.g. the actor, who, what
    noun?: string;
    // Either or
}

export interface ITimelineEntryCommon {
    verb?: string; // the action that took place 

    text?: string;
    location?: IPlot;
}

@Component({
    selector: "v-timeline",
    template: require("./v-timeline.component.html")
})
export class VTimelineComponent implements OnChanges, AfterContentInit {

    @Input() entries: ITimelineEntry[] = [];

    @Input() showTime: boolean;

    @Input() dateFormat: string = 'time';

    @Input() dateFormatOptions: IDateFormatOptions = { dateTime: true };

    @Input() sortByNew: boolean;

    @ViewChild("ngcontent", { static: true }) ngContentContainer: ElementRef;

    // ---

    hasNgContent = true;

    constructor(private veriDate: VeriDate) {
    }

    ngOnChanges() {
        // Sort incoming data
        if (this.entries) {
            this.entries.sort((x, y) => this.veriDate.sort(x.date, y.date, this.sortByNew ? SortDirection.Descending :SortDirection.Ascending));
            this.entries.forEach(entry => {
                if ((entry.largeDetails && entry.largeDetails.verb && entry.largeDetails.listItems?.some(item => item.date)) || entry.inlineDetails) {
                    entry.showDateFooter = false;
                }
                else {
                    entry.showDateFooter = true;
                }
            })
        }
    }

    ngAfterContentInit() {
        var element = this.ngContentContainer.nativeElement as HTMLElement;
        //console.log(this.ngContentContainer, element.childNodes, element.hasChildNodes(), element.innerHTML);

        if (element.innerHTML.trim() == '') {
            element.parentElement.remove();
        }
    }
}
